import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store, { rootReducer } from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
import { useEffect } from "react";

const Number = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayYes = fieldEle?.["display-yes"];
  const parentSelectedValue = displayYes ? formState[displayYes] : "";
  const shouldDisplay = parentSelectedValue?.toLowerCase() === "yes";

  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      rootReducer.dispatch(
        setRendererFormState({ key: databaseKey, value: "" })
      );
    }
  }, [displayYes, shouldDisplay, databaseKey]);

  if (displayYes && !shouldDisplay) {
    return null;
  }

  const maxDigits = parseInt(fieldEle?.["validation-maxvalue"]);
  const minDigits = parseInt(fieldEle?.["validation-minvalue"]);

  const handleInputChange = (e) => {
    let value = e.target.value;
    if (!/^\d*$/.test(value)) {
      return;
    }
    if (value.length > maxDigits) {
      value = value.slice(0, maxDigits);
    }
    if (value.length > maxDigits) {
      value = value.slice(0, minDigits);
    }

    rootReducer.dispatch(setRendererFormState({ key, value }));
  };

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element no-arrows"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <style>{`
          /* Hide the spinner controls */
          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          input[type="number"] {
            -moz-appearance: textfield; /* Firefox */
          }
        `}</style>
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className="form-control mandatory"
          type="number"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          required={showRequired ? fieldEle?.["display-required"] === 1 : false}
          // min={fieldEle?.["validation-minvalue"]}
          // max={fieldEle?.["validation-maxvalue"]}
          name={key}
          value={formState[key] || ""}
          pattern={fieldEle?.["validation-pattern"]}
          onChange={handleInputChange}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Number;
